module.exports = __webpack_public_path__ + "media/images/icons/twitter-icon-db226d55c343637e1371fc247b144b51.svg";